// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IReducedPolicyStatusDto
 */
export interface IReducedPolicyStatusDto {
    /**
     * 
     * @type {string}
     * @memberof IReducedPolicyStatusDto
     */
    status?: IReducedPolicyStatusDtoStatusEnum;
    /**
     * 
     * @type {Date}
     * @memberof IReducedPolicyStatusDto
     */
    valid_from?: Date;
    /**
     * 
     * @type {Date}
     * @memberof IReducedPolicyStatusDto
     */
    valid_to?: Date;
}

/**
* @export
* @enum {string}
*/
export enum IReducedPolicyStatusDtoStatusEnum {
    ACTIVE = 'ACTIVE',
    CANCELED = 'CANCELED',
    FUTURE = 'FUTURE',
    EXPIRED = 'EXPIRED'
}


/**
 * Check if a given object implements the IReducedPolicyStatusDto interface.
 */
export function instanceOfIReducedPolicyStatusDto(value: object): value is IReducedPolicyStatusDto {
    return true;
}

export function IReducedPolicyStatusDtoFromJSON(json: any): IReducedPolicyStatusDto {
    return IReducedPolicyStatusDtoFromJSONTyped(json, false);
}

export function IReducedPolicyStatusDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IReducedPolicyStatusDto {
    if (json == null) {
        return json;
    }
    return {
        
        'status': json['status'] == null ? undefined : json['status'],
        'valid_from': json['valid_from'] == null ? undefined : (new Date(json['valid_from'])),
        'valid_to': json['valid_to'] == null ? undefined : (new Date(json['valid_to'])),
    };
}

export function IReducedPolicyStatusDtoToJSON(json: any): IReducedPolicyStatusDto {
    return IReducedPolicyStatusDtoToJSONTyped(json, false);
}

export function IReducedPolicyStatusDtoToJSONTyped(value?: IReducedPolicyStatusDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'status': value['status'],
        'valid_from': value['valid_from'] == null ? undefined : ((value['valid_from']).toISOString().substring(0,10)),
        'valid_to': value['valid_to'] == null ? undefined : ((value['valid_to']).toISOString().substring(0,10)),
    };
}

